<template>
<div>
    <div class="table-responsive">
        <table class="table table-striped">
            <thead class="">
                <tr>
                    <th style="vertical-align: center !important;">Processo</th>
                    <th style="text-align:center !important;">Modalidade/Nº</th>
                    <th style="text-align:center !important;">Fase</th>
                    <th>Objeto</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="itens in dadosconteudo.tr">
                    <td v-if="itens.processo != ''" :rowspan="itens.rowspan" style="vertical-align: top !important;">       {{itens.processo}}
                    </td>
                    <td style="text-align:center !important; vertical-align: top !important;">{{{itens.modalidade}}}</td>
                    <td style="text-align:center !important; vertical-align: top !important;">
                        <a class="abrirpdf" v-if="itens.telamodal == false" :href="itens.linkfase" target="_blank">{{{itens.fase}}}</a>
                        <span style="cursor:pointer;color: #5b9bd1;" v-else @click="loadmodal(itens)">{{{itens.fase}}}</span>
                        <modal-user v-if="itens.telamodal == true" :line="itens" :idmodaln="itens.moduser"></modal-user>  
                    </td>
                    <td style="text-align:left !important;">
                        <!-- <a href="javascript:;" data-toggle="modal" :data-target="'#'+itens.infomodal" title="Detalhes da Licitação"> -->
                        <span style="cursor:pointer;color: #5b9bd1;" @click="loadmodalinfomodal(itens.infomodal)">
                            {{itens.objeto}}
                        </span>
                        <info-modal :line="itens.infomodal"></info-modal>
                    </td>
                </tr>
            </tbody>
        </table>

        <div class="text-center">
            <cp-paginate :source="dadosconteudo" @navigate="navigate"><cp-paginate>
        </div>
    </div>
    <!-- Modal de informações -->
    <!-- <div v-for="modinfo in dadosconteudo.tr" :key="modinfo.index">
        <info-modal :line="modinfo.infomodal"></info-modal>
    </div> -->
    <!-- fim Modal de informações -->
    <!-- Modal de informações -->
        <!-- <div v-for="userfase in dadosconteudo.tr" :key="userfase.index">
            {{userfase.idfase}}
            
        </div> -->
    <!-- fim Modal de informações -->
</div>
</template>
<script>
    import InfoModal from './modal/infomodal.vue'
    import CpPaginate from '../../pagination/pagination.vue'
    import ModalUser from './modaluser/usermodal.vue'

    export default{
        data() {
            return{
                dadostable: {},
                telamodal: true,
                newdados: {}
            }
        },
        components: { InfoModal, CpPaginate, ModalUser },
        ready() {
            // $.getScript("./src/assets/js/puremask.min.js");
            $('.table-responsive').fadeOut('fast');
        },
        watch: {
            $route() {
                $('.table-responsive').fadeOut('fast');
            }
        },
        props: ['dadosconteudo'],
        methods: {
            loadmodalinfomodal(item){
                setTimeout(function(){
                    $('#'+item).modal('show');
                }, 300);
            },
            loadmodal(item){
                var self = this;

                setTimeout(function(){
                    $('#'+item.moduser).modal('show');
                }, 300);
            },
            navigate(page) {
                $.ajaxSetup({
                    async: false
                });                            

                var self = this

                MPL.loadDadosLicitacao(page, function (dados)
                {
                    //self.dadosconteudo = dados[0];
                    self.dadosconteudo = dados[0];
                    self.dadostable = dados[0];
                    //alert(self.$route.params.tipo)
                    //console.log(dados[0].conteudo)
                });

                $.ajaxSetup({
                    async: true
                });
            }
        }
    }
</script>
<style scoped>
.abrirpdf:hover{
    text-decoration: none;
    color: #5b9bd1;
}
</style>


// WEBPACK FOOTER //
// table.vue?0c6e7183